import { render } from "./ProductInformation.vue?vue&type=template&id=6687bed8&scoped=true"
import script from "./ProductInformation.vue?vue&type=script&lang=js"
export * from "./ProductInformation.vue?vue&type=script&lang=js"

import "./ProductInformation.vue?vue&type=style&index=0&id=6687bed8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6687bed8"]])

export default __exports__